// extracted by mini-css-extract-plugin
export default {"secondaryPrice":"zlp9T","gridPrice":"_v2Fe","primaryPrice":"xifcn","complementaryPrimaryPrice":"gt1u6"};